/** "Ann", "Ann and Bob", "Ann, Bob and Cid". */
export function formatAuthorNames(names: string[]): string {
  if (names.length <= 1) {
    return names[0] ?? '';
  }
  return `${names.slice(0, -1).join(', ')} and ${names.at(-1)}`;
}
